// src/routes/dashboard/components/FlowChart.tsx
/** Create vs completate negli ultimi 6 mesi. GinoriChart supporta un solo yKey, quindi
 *  per le due serie usiamo recharts direttamente, come in AnalyticsDashboard. */
import React from 'react';
import { Card, Title } from '@mantine/core';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { MonthlyFlowPoint } from '../../../types/api';
import { formatMonthShort } from '../dashboard-meta';

interface FlowChartProps {
  data: MonthlyFlowPoint[];
}

export function FlowChart({ data }: FlowChartProps) {
  const chartData = data.map((p) => ({
    name: formatMonthShort(p.year, p.month),
    Create: p.created,
    Completate: p.completed,
  }));

  return (
    <Card withBorder p="md" h="100%">
      <Title order={4} mb="sm">
        Create vs completate (ultimi 6 mesi)
      </Title>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Legend />
          <Bar dataKey="Create" fill="#228BE6" />
          <Bar dataKey="Completate" fill="#40C057" />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
}
